import { createActions, createState, createReducer } from 'reduxsauce-crud'

export const ConsumablesCategoriesRedux = createActions(
  {},
  {
    prefix: 'CONSUMABLES_CATEGORIES_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = ConsumablesCategoriesRedux
export const ContractsTypes = Types
export default Creators

export const INITIAL_STATE = createState({
},
{
  get: true,
})

export const reducer = createReducer(
  INITIAL_STATE, {
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ConsumablesCategoriesRedux.js